import React from "react";
import { View, Text } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import { Image } from "expo-image";
import Images from "@/assets/images";
import Icons from "@/assets/icons";

const OnboardSlide9 = () => {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {/* Brand icons scattered layout */}
        <View style={styles.brandsContainer}>
          {/* Spotify - green circle with black logo */}
          <View style={styles.brandIcon1}>
            <Icons.SpotifyCircle width={64} height={64} />
          </View>
          {/* Poppi - pink/magenta circle */}
          <View style={styles.brandIcon2}>
            <Image
              source={Images.brandPoppiCircle}
              style={styles.brandImage}
              contentFit="cover"
            />
          </View>
          {/* Netflix - black circle with N */}
          <View style={styles.brandIcon3}>
            <Image
              source={Images.brandNetflixCircle}
              style={styles.brandImage}
              contentFit="cover"
            />
          </View>
          {/* Apple - black circle with white Apple logo */}
          <View style={styles.brandIcon4}>
            <Icons.AppleCircle width={68} height={68} />
          </View>
          {/* Amazon - orange circle */}
          <View style={styles.brandIcon5}>
            <Image
              source={Images.brandAmazonOrange}
              style={styles.brandImage}
              contentFit="cover"
            />
          </View>
        </View>

        <View style={styles.textContainer}>
          <Text style={styles.title}>Start with 2 free claims</Text>
          <Text style={styles.subtitle}>
            Every month, get new claims for free. Invite friends to earn extra.
          </Text>
        </View>
      </View>
    </View>
  );
};

export default OnboardSlide9;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 32,
    justifyContent: "center",
  },
  content: {
    alignItems: "center",
    gap: 16,
  },
  brandsContainer: {
    width: 280,
    height: 180,
    position: "relative",
  },
  brandIcon1: {
    position: "absolute",
    left: 10,
    top: 11,
    width: 64,
    height: 64,
    borderRadius: 100,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 10,
    elevation: 5,
  },
  brandIcon2: {
    position: "absolute",
    left: 111,
    top: 2,
    width: 68,
    height: 68,
    borderRadius: 100,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 3,
  },
  brandIcon3: {
    position: "absolute",
    left: 207,
    top: 26,
    width: 64,
    height: 64,
    borderRadius: 100,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 10,
    elevation: 5,
  },
  brandIcon4: {
    position: "absolute",
    left: 57,
    top: 79,
    width: 68,
    height: 68,
    borderRadius: 1000,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 10,
    elevation: 5,
  },
  brandIcon5: {
    position: "absolute",
    left: 145,
    top: 90,
    width: 68,
    height: 68,
    borderRadius: 100,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 3,
  },
  brandImage: {
    width: "100%",
    height: "100%",
  },
  textContainer: {
    alignItems: "center",
    gap: 10,
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#161D14",
    textAlign: "center",
  },
  subtitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 16,
    lineHeight: 24,
    color: "#161D14",
    textAlign: "center",
    opacity: 0.7,
    letterSpacing: -0.32,
  },
});
